import { ACTION, GenericObject, actionKeyGenerate } from "src/util/utils";

export const MODULE_KEY = "REPLENISHMENT_JOB_CONFIG_UPDATE";

export const KEYS: GenericObject = actionKeyGenerate(MODULE_KEY);

export const REPLENISHMENT_JOB_CONFIG_UPDATE_FETCH = KEYS[MODULE_KEY + ACTION.FETCH];

export const fetchReplenishmentJobConfigUpdateSummary = (payload: any) => ({
  type: REPLENISHMENT_JOB_CONFIG_UPDATE_FETCH,
  payload,
});

export const fetchReplenishmentJobConfigUpdateSummarySuccess = (payload: any) => ({
  type: KEYS[MODULE_KEY + ACTION.SUCCESS],
  payload,
});

export const fetchReplenishmentJobConfigUpdateSummaryFailed = (payload: any) => ({
  type: KEYS[MODULE_KEY + ACTION.FAILED],
  payload,
});
